import { render, staticRenderFns } from "./tdGroupNameLink.vue?vue&type=template&id=e18e8fa2&scoped=true"
import script from "./tdGroupNameLink.vue?vue&type=script&lang=js"
export * from "./tdGroupNameLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18e8fa2",
  null
  
)

export default component.exports